import { EnvelopeIcon, PhoneIcon } from '@heroicons/react/20/solid'
import ListServices from './ListServices'
import ManageService from './ManageService';
import NewServiceForm from './NewServiceForm';
import { Fragment, useEffect, useState } from 'react'
import { Dialog, DialogPanel, DialogTitle, Transition, TransitionChild } from '@headlessui/react'
import { useSelector } from 'react-redux';



export default function Manage() {
  const token = useSelector((state) => state.auth.token);
  const [open, setOpen] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [addService, setAddService] = useState(false);
  const [servicesList, setServicesList] = useState([]);
  const user = useSelector((state) => state.auth.user);


  useEffect(() => {
    fetch(`${process.env.REACT_APP_SERVICE_API_URL}/provider/${user.id}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
          'Api-Name': 'service-api',
        }
      }
    )
      .then(response => response.json())
      .then(data => setServicesList(data.services))
      .catch(error => console.error(error));
  }, []);

  const handleAddClick = () => {
    setShowForm(true);
    setAddService(true);
  };

  const handleFormSubmit = () => {
    // Handle form submission here
    setShowForm(false);
  };

  const handleCancelClick = () => {
    setShowForm(false);
  };

  if (!servicesList) {
    return <div>Loading...</div>;
  }

  return (
    <div className="flex flex-col lg:flex-row items-center justify-center">
      {servicesList.length === 0 ? 
        <h1 className="lg:text-4xl text-lg text-pri-white items-center justify-center p-5 m-2">No Services found</h1>
      : null}

      {servicesList.length < 5 ? (
          <div onClick={handleAddClick} className="p-4 flex w-full items-center justify-center space-x-6 p-6 rounded-full bg-sec-dark shadow-md shadow-pri-dark-shadow w-8 h-8 lg:max-w-16 lg:max-h-16 active:translate-y-1 active:shadow-none">
            <p className="text-4xl text-pri-white">+</p>
          </div>
      ) : null}

      <ListServices servicesList={servicesList} setServicesList={setServicesList}/>

      {showForm ?
        <div className="bg-sec-dark">
          <Transition show={open}>
      <Dialog className="relative z-10" onClose={handleCancelClick}>
        <TransitionChild
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </TransitionChild>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <TransitionChild
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <DialogPanel className="relative transform overflow-hidden rounded-lg bg-white px-8 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6">
              <div className="bg-dark-modal p-8 rounded-3xl">
              <NewServiceForm servicesList={servicesList} setShowForm={setShowForm} setServicesList={setServicesList}/>
              </div>
              </DialogPanel>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </Transition>
        </div>
          

       : null}
      </div>
  )
}
